import React, { useState } from 'react';

const faqs = [
  {
    question: 'What does WhiteOwl actually do?',
    answer: 'WhiteOwl is an AI-powered sales assistant that automates the consulting sales cycle, from identifying and qualifying leads to generating briefs, pitches, and proposals.'
  },
  {
    question: 'Does it replace consultants or sales teams?',
    answer: 'No. WhiteOwl is an AI assistant for consultants. It augments their work by cutting down repetitive tasks. It helps you gather sales intelligence, research information, and create winning proposals. WhiteOwl becomes your partner in sales success by accelerating closures and winning more deals.'
  },
  {
    question: "Is my client's data safe?",
    answer: 'Absolutely. WhiteOwl utilises enterprise encryption and APIs that adhere to global data privacy standards. We are an ISO 27001 company. Your data is used only for the purpose you need; there is no unauthorised access, and your information remains safe and confidential.'
  },
  {
    question: 'Will my work or my client data be used to train the AI?',
    answer: 'No. Your data is never shared or reused to train our global AI models or across our other client accounts. WhiteOwl only uses your data to personalise and improve your experience. For example, remembering context, tailoring briefs, and refining proposals for your account. Everything in your login stays with you. For more details, you can read our privacy policy.'
  },
  {
    question: 'How can I start using WhiteOwl?',
    answer: (
      <>
        Getting started with WhiteOwl is quick and easy. We are providing a FREE account with 1000 credits for consulting firms. You will receive:
        <br /><br />
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Sales and account intelligence.</strong></li>
          <li> 1 Geography, 2 Industries, 5 Triggers, 3 Personas</li>
          <li>10 Account & People Watchlist</li>
          <li>Consulting firm's knowledge profile</li>
          <li>AI research and AI doc creation</li>
          <li>Standard templates for research and doc</li>
          <li>200 MB storage</li>
        </ul>
      </>
    )
  },
  {
    question: 'How does WhiteOwl ensure accuracy and avoid hallucination?',
    answer: "WhiteOwl draws signals and insights based on the consulting firm's business offerings, industries, and the type of client you are catering to. The platform gives you the option to add/remove your target geographies, clients, industries, target persona and target segment on which it generates triggers. These triggers are further customisable. Based on the provided inputs, it crawls the trusted web sources to bring you the most relevant sales signals. We utilise a combination of technical strategies, data practices, and control to maximise accuracy and avoid hallucinations. Whether it's a signal about funding, leadership changes, mergers and acquisitions, or hiring, you can check the exact source of the information by clicking on it."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <style>{`
        .faq-answer-container {
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out, padding 0.3s ease-in-out;
        }
        .faq-answer-container.open {
          max-height: 2000px;
          opacity: 1;
        }
        .faq-answer-content {
          padding: 0 1.5rem ;
          transition: padding 0.3s ease-in-out;
        }
        .faq-answer-container.open .faq-answer-content {
          padding-top: 0.75rem;
          padding-bottom: 0.75rem;
        }
        @media (min-width: 640px) {
          .faq-answer-container.open .faq-answer-content {
            padding-top: 1rem;
            padding-bottom: 1rem;
          }
        }
      `}</style>
      <section className="py-10 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-10 md:mb-12 leading-tight">
            Frequently asked <span className="text-[#007BE5]">questions</span>
          </h2>
          
          <div className="space-y-3 sm:space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-lg sm:rounded-xl shadow-sm overflow-hidden border border-gray-100"
              >
                <button
                  className="w-full px-4 sm:px-5 md:px-6 py-3 sm:py-4 text-left flex justify-between items-start sm:items-center gap-3 sm:gap-4 hover:bg-gray-50 active:bg-gray-100 transition-colors touch-manipulation"
                  onClick={() => toggleQuestion(index)}
                  style={{ WebkitTapHighlightColor: 'transparent' }}
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-answer-${index}`}
                >
                  <span className="text-base sm:text-lg md:text-lg font-medium text-gray-900 flex-1 min-w-0 leading-relaxed">
                    {faq.question}
                  </span>
                  <svg
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 transform transition-transform duration-300 ease-in-out text-gray-600 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                
                <div 
                  id={`faq-answer-${index}`}
                  className={`faq-answer-container border-t border-gray-100 ${openIndex === index ? 'open' : ''}`}
                >
                  <div className="faq-answer-content px-4 sm:px-5 md:px-6">
                    {typeof faq.answer === 'string' ? (
                      <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{faq.answer}</p>
                    ) : (
                      <div className="text-sm sm:text-base text-gray-600 leading-relaxed">{faq.answer}</div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ; 